import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  SimpleChanges,
  viewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Subject } from 'rxjs';

@Component({
    imports: [CommonModule],
    template: ''
})
export class BaseFormKitComponent {
  //#region properties
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() id: any='';
  @Input() label: string = '';
  @Input() control: FormControl | any;
  @Input() placeholder: string = '';
  @Input() classList: string = '';
  @Input() fontSize: string = '14px';
  @Input() isLtr: boolean = false;
  @Input() textAlign: 'right' | 'left' | 'center' | 'justify' = 'right'
  @Input() isReadOnly: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isShowValidationStatusIcon: boolean = true;
  @Input() hasMatPrefix: boolean = false;
  @Input() hasMatSuffix: boolean = false;
  @Input() checkAppDirection: boolean = true;
  @Input() loading: boolean = false;
  @Input() required: boolean = false;
  @Input() description: string;

  readonly prefixContent = viewChild<ElementRef>('prefixContent');
  readonly suffixContent = viewChild<ElementRef>('suffixContent');


  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();
  @Output('change') formFieldChange = new EventEmitter<any>();

  defaultControl: FormControl = new FormControl();
  protected onDestroy$ = new Subject<void>();

  //#endregion

  @HostBinding('class') class = this.isLtr ? 'dir-ltr' : 'dir-rtl';

  ngOnInit() {
    this.checkAppDirectionByHtmlDirection();
  }

  checkAppDirectionByHtmlDirection() {
    try {
      if (!this.checkAppDirection) return;
      const dir = document.getElementsByTagName('html')[0].getAttribute('dir');
      if (this.isLtr) return;
      if (dir == 'rtl') { this.isLtr = false; this.textAlign = 'right' }
      else if (dir == 'ltr') { this.isLtr = true; this.textAlign = 'left'; }
      else { this.isLtr = false; this.textAlign = 'right' }
    } catch (error) {
      console.error('BaseFormKitComponent Error => ', error)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['isDisabled']) this.handleEnableStateControl();
  }

  ngAfterContentChecked(): void {
    try {
      this.hasMatPrefix = !!this.prefixContent()?.nativeElement?.childNodes?.length;
      this.hasMatSuffix = !!this.suffixContent()?.nativeElement?.childNodes?.length;
    } catch (error) {
      console.error('BaseFormKitComponent Error => ', error)
    }
  }

  handleEnableStateControl() {
    try {
      if (this.isDisabled) {
        (this.control as FormControl)?.disable();
        this.defaultControl?.disable();
      } else {
        (this.control as FormControl)?.enable();
        this.defaultControl?.enable();
      }
    } catch (error) {
      console.error('BaseFormKitComponent Error => ', error)
    }
  }

  emitValue(value?) {
    this.valueChange.emit(value || this.value);
  }

  emitChangeEvent(event) {
    this.formFieldChange.emit(event);
  }

  unSubs(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngOnDestroy(): void {
    this.unSubs();
  }
}
